(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('selectOnClick', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('click', function () {
          this.select();
        });
      }
    };
  });
})(window, window.angular);
